import { render, staticRenderFns } from "./ToCollectors.vue?vue&type=template&id=0af16217&scoped=true&"
import script from "./ToCollectors.vue?vue&type=script&lang=js&"
export * from "./ToCollectors.vue?vue&type=script&lang=js&"
import style0 from "./ToCollectors.vue?vue&type=style&index=0&id=0af16217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af16217",
  null
  
)

export default component.exports